const settings = {
  language: "Язык",
  hebrew: "Иврит",
  english: "Английский",
  russian: "Русский",
  sidebarPosition: "Позиция боковой панели",
  right: "Справа",
  left: "Слева",
  sidebarVisibility: "Видимость боковой панели",
  visible: "Видимая",
  float: "Плавающая",
  hidden: "Скрытая",
  themeMode: "Оформление",
  themeModeDark: "Тёмная",
  themeModeLight: "Светлая",
  theme: "Тема",
  accentColor: "Акцентный цвет",
  fontFamily: "Шрифт",
  borderRadius: "Скругление углов",
  density: "Плотность",
  textSize: "Размер текста",
  textNormal: "Обычный",
  textLarge: "Крупный",
  textXLarge: "Очень крупный",
  sharp: "Острые",
  default: "По умолчанию",
  round: "Круглые",
  compact: "Компактно",
  spacious: "Просторно",
  heebo: "Heebo",
  geist: "Geist",
  inter: "Inter",
  system: "Системный",
  openSettings: "Открыть настройки",
  tabGeneral: "Общие",
  tabTheme: "Тема",
  tabBrand: "Бренд",
  tabWidgetBar: "Панель виджетов",
  activeProfile: "Активный профиль",
  noActiveProfile: "Профиль не выбран",
  profileModified: "(изменён)",
  saveNewProfile: "Сохранить как новый профиль",
  profileNamePlaceholder: "Название профиля...",
  savedProfiles: "Сохранённые профили",
  noProfiles: "Нет сохранённых профилей",
  loadProfile: "Загрузить",
  renameProfile: "Переименовать",
  overwriteProfile: "Обновить профиль",
  updateProfile: "Обновить существующий профиль",
  builtIn: "Встроенный",
  profileDefault: "По умолчанию",
  profileMinimal: "Минимальный",
  profileLoaded: "Профиль загружен",
  profileSaved: "Профиль сохранён",
  profileDeleted: "Профиль удалён",
  colorPicker: "Выбор цвета",
  myPalette: "Моя палитра",
  noSavedColors: "Нет сохранённых цветов",
  colorCombos: "Цветовые комбинации",
  effects: "Эффекты",
  gradient: "Градиент",
  gradientDirection: "Направление",
  secondaryColor: "Вторичный цвет",
  glow: "Свечение",
  glowIntensity: "Интенсивность",
  subtle: "Мягкое",
  medium: "Среднее",
  strong: "Сильное",
  useAsAccent: "Использовать как акцент",
  saveToPalette: "Сохранить в палитру",
  custom: "Пользовательский",
  on: "Вкл",
  off: "Выкл",
  comboSunset: "Закат",
  comboOcean: "Океан",
  comboAurora: "Северное сияние",
  comboForest: "Лес",
  comboFlame: "Пламя",
  comboRoyal: "Королевский",
  comboMidnight: "Полночь",
  comboRoseGold: "Розовое золото",
  comboGlacier: "Ледник",
  lockColor: "Закрепить цвет",
  unlockColor: "Открепить",
  useAsBrand: "Использовать как цвет бренда",
  removeColor: "Удалить цвет",
  colorArchive: "Архив цветов",
  noArchivedColors: "Нет архивных цветов",
  restoreColor: "Восстановить",
  deletePermanently: "Удалить навсегда",
  navColor: "Цвет навигации",
  navColorHint: "Цвет фона боковой и верхней панели",
  resetNavColor: "Сбросить (следовать за темой)",
  colorTheme: "Цветовая тема",
  darkThemes: "Тёмные",
  lightThemes: "Светлые",
  tabPwa: "PWA",
  gibberishDetect: "Обнаружение неправильной клавиатуры",
  gibberishDetectHint: "Автоматическое обнаружение при вводе на неправильном языке",
  gibberishMeantHebrew: "Вы имели в виду иврит?",
  gibberishMeantEnglish: "Вы имели в виду английский?",
  gibberishConvert: "Конвертировать",
  tabAccounts: "Интеграции",
  tabEmailTemplates: "Шаблоны email",
  tabProfile: "Профиль",
  tabSearch: "Поиск",
  tabSystem: "Система",
  tabUsers: "Пользователи",
  tabLogin: "Вход",
  tabShortcuts: "Горячие клавиши",
  connectedAccounts: "Подключённые аккаунты",
  connectGoogle: "Подключить Google",
  googleSection: "Google",
  scopeGmail: "Gmail",
  scopeCalendar: "Календарь",
  disconnect: "Отключить",
  disconnectConfirm: "Вы уверены, что хотите отключить этот аккаунт?",
  accountConnected: "Аккаунт успешно подключён",
  accountDisconnected: "Аккаунт отключён",
  active: "Активен",
  inactive: "Неактивен",
  noAccounts: "Нет подключённых аккаунтов",
  noAccountsHint: "Подключите Google для доступа к Gmail и Календарю",
  integrationsTitle: "Центр интеграций",
  sectionAuthSecurity: "Аутентификация и безопасность",
  sectionCommunication: "Коммуникационные сервисы",
  sectionExternalServices: "Внешние сервисы",
  sectionMessaging: "Кредиты сообщений",
  currentLoginMethod: "Текущий метод входа",
  connectedProviders: "Подключённые провайдеры",
  linkProvider: "Привязать",
  unlinkProvider: "Отвязать",
  noProviders: "Нет подключённых провайдеров",
  otpEnabled: "OTP включён",
  otpDisabled: "OTP отключён",
  webhookUrl: "URL Webhook",
  copied: "Скопировано!",
  copyUrl: "Копировать",
  configured: "Настроен",
  notConfigured: "Не настроен",
  connected: "Подключён",
  comingSoon: "Скоро",
  testConnection: "Проверить подключение",
  connectionOk: "Подключение ОК",
  connectionFailed: "Подключение не удалось",
  watiWhatsapp: "WATI — WhatsApp",
  voicenterPbx: "Voicenter — АТС",
  origamiCrm: "Origami CRM",
  notionIntegration: "Notion",
  n8nAutomation: "n8n — Автоматизация",
  zapierIntegration: "Zapier",
  makeIntegration: "Make",
  smsCredits: "SMS (Twilio)",
  emailCredits: "Email (Resend)",
  providerEmail: "Email + Пароль",
  providerOtp: "Одноразовый код",
  providerGithub: "GitHub",
  providerFacebook: "Facebook",
  providerMicrosoft: "Microsoft",
  providerApple: "Apple",
  providerLinkedin: "LinkedIn",
  providerGoogle: "Google",
  tabSkins: "Скины",
  skinsTitle: "Скины — стиль отображения",
  skinsSubtitle: "Выберите стиль для каждого слоя отдельно",
  skinShellTitle: "Оболочка (Shell)",
  skinShellDesc: "Сайдбар, верхняя панель, навигация — внешняя рамка приложения",
  skinContentTitle: "Контент (Страницы)",
  skinContentDesc: "Карточки, таблицы, формы — внутренний дизайн страниц",
  skinMobileNavTitle: "Мобильная навигация",
  skinMobileNavDesc: "Стиль навигации на маленьких экранах",
  skinCurrent: "Текущий",
  skinFeatures: "Функции",
  skinSafetyNote: "Безопасность",
} as const;
export default settings;
